import { Image, Modal, Radio, Typography } from '@smartgift/frontend-toolkit';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import * as S from './style';

function ThankYouReplySettingsModal({
  isOpen,
  onRequestClose,
  receiveThankYouNotes,
  setReceiveThankYouNotes,
  onPrimaryButtonClick,
  senderName,
  isLoading
}) {
  const { t } = useTranslation();
  const theme = useTheme();
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      primaryButtonProps={{
        onClick: onPrimaryButtonClick,
        children: t('next'),
        endIcon: 'next',
        loading: isLoading
      }}
      title={t('keepTheConversation')}
      size="lg"
    >
      <S.ThankYouReplySettingsModalWrapper>
        <S.ItemWrapper>
          <Typography variant="body2Bold">
            <Trans i18nKey="keepTheConversationTitle" components={{ b: <b /> }} />
          </Typography>

          <Radio
            labelPosition="left"
            label={
              <>
                <Typography variant="body2Bold">{t('keepTheConversationYes')}</Typography>
                <Typography emphasis="weak" color="fg" variant="body2">
                  {t('keepTheConversationYesInfo')}
                </Typography>
              </>
            }
            value="preview"
            checked={receiveThankYouNotes}
            onChange={() => {
              setReceiveThankYouNotes(true);
            }}
          />
          <Radio
            label={
              <>
                <Typography variant="body2Bold">{t('keepTheConversationNo')}</Typography>
                <Typography emphasis="weak" color="fg" variant="body2">
                  {t('keepTheConversationNoInfo')}
                </Typography>
              </>
            }
            value="preview"
            checked={!receiveThankYouNotes}
            onChange={() => {
              setReceiveThankYouNotes(false);
            }}
          />
        </S.ItemWrapper>
        <S.ItemWrapper>
          <Image
            onLoad={() => setIsImageLoaded(true)}
            src={!receiveThankYouNotes ? theme.images.viaReplyTable : theme.images.viaReplyPreview}
          />
          {isImageLoaded && receiveThankYouNotes && (
            <S.ExampleThankYouWrapper>
              <Typography color="fg" variant="body2">
                {t('thankYouExampleSubject', {
                  senderName
                })}
              </Typography>
              <S.ExampleThankYou>
                <Typography variant="caption2Regular">{t('thankYouExampleBody')}</Typography>
              </S.ExampleThankYou>
              <S.BottomInfo>
                <span>📬</span>
                <Typography color="fg" variant="caption2Regular">
                  {t('youCanReply')}
                </Typography>
              </S.BottomInfo>
            </S.ExampleThankYouWrapper>
          )}
        </S.ItemWrapper>
      </S.ThankYouReplySettingsModalWrapper>
    </Modal>
  );
}

export { ThankYouReplySettingsModal };
